// removed by extract-text-webpack-plugin
module.exports = {"sticky-background":"sticky-background__2sELe","fixed":"fixed__rLQpb","disable-sticky-mobile":"disable-sticky-mobile__2K1DA","fixed-bottom":"fixed-bottom__2hthK","sticky-on-mobile":"sticky-on-mobile__1vRd7","shadow":"shadow__2NqT5","padding":"padding__1Aa2T"};


//////////////////
// WEBPACK FOOTER
// ./styles/sticky.scss
// module id = 1104
// module chunks = 68